const initialPageInstructionsState = [
  {
    instructionId: 'coming-soon',
    instructionName: 'Coming soon.....',
    instructionLink: '#Link1',
  },
];

// Help-menu instructions are seeded from static state and rendered by HelpMenu;
// there is no runtime action that updates them, so the reducers simply return state.
export const pageInstructionsReducer = (state = initialPageInstructionsState) => state;

const moreInstructionsState = [
  {
    instructionId: 'additional-helpContent',
    instructionName: 'Additional Help Content',
    instructionLink: 'https://www.americanexpress.com/content/dam/amex/us/merchant/pdf/FileXpress-User-Guide.pdf',
  },
];

export const moreInstructionsReducer = (state = moreInstructionsState) => state;
